var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "default-layout",
    {
      attrs: {
        title: _vm.t("ActivateSentPage.pageTitle"),
        "sub-title": _vm.t("ActivateSentPage.subTitle"),
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "contact-support-link block-button",
          attrs: { target: "_blank", href: _vm.contactSupportUrl },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.t("ActivateSentPage.contactSupportButton")) +
              "\n  "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }